import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../Services/Api/ApiServices";


export const GetAllBudgetItemsRequestedFromSomanByAppGuid = createAsyncThunk(
  "BudgetItemsRequestedFromSoman/GetAllBudgetItemsRequestedFromSomanByAppGuid",
  async (parameters, { rejectWithValue }) => {
    try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
            "api/SU_NT_WPB_BudgetItemsRequestedFromSoman/GetAllBudgetItemsRequestedFromSomanByAppGuid",
            parameters
          );

          const data = response.data.result; // Assuming response has a "data" field
          return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetBudgetItemsRequestedFromSomanById = createAsyncThunk(
    "BudgetItemsRequestedFromSoman/GetBudgetItemsRequestedFromSomanById",
    async (parameters, { rejectWithValue }) => {
      try {
          await initializeApiClient();
          const apiClient = await getApiClient();
          const response = await apiClient.post(
              "api/SU_NT_WPB_BudgetItemsRequestedFromSoman/GetBudgetItemsRequestedFromSomanById",
              parameters
            );
  
            const data = response.data.result; // Assuming response has a "data" field
            return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );


  export const DeleteBudgetItemsRequestedFromSomanById = createAsyncThunk(
    "BudgetItemsRequestedFromSoman/DeleteBudgetItemsRequestedFromSomanById",
    async (parameters, { rejectWithValue }) => {
      try {
          await initializeApiClient();
          const apiClient = await getApiClient();
          const response = await apiClient.post(
              "api/SU_NT_WPB_BudgetItemsRequestedFromSoman/DeleteBudgetItemsRequestedFromSomanById",
              parameters
            );
  
            const data = response.data.result; // Assuming response has a "data" field
            return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );


  export const AddBudgetItemsRequestedFromSoman = createAsyncThunk(
    "BudgetItemsRequestedFromSoman/AddBudgetItemsRequestedFromSoman",
    async (parameters, { rejectWithValue }) => {
      try {
          await initializeApiClient();
          const apiClient = await getApiClient();
          const response = await apiClient.post(
              "api/SU_NT_WPB_BudgetItemsRequestedFromSoman/AddBudgetItemsRequestedFromSoman",
              parameters
            );
  
            const data = response.data.result; // Assuming response has a "data" field
            return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );


  export const EditBudgetItemsRequestedFromSoman = createAsyncThunk(
    "BudgetItemsRequestedFromSoman/EditBudgetItemsRequestedFromSoman",
    async (parameters, { rejectWithValue }) => {
      try {
          await initializeApiClient();
          const apiClient = await getApiClient();
          const response = await apiClient.post(
              "api/SU_NT_WPB_BudgetItemsRequestedFromSoman/EditBudgetItemsRequestedFromSoman",
              parameters
            );
  
            const data = response.data.result; // Assuming response has a "data" field
            return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );


  export const ValidationBudgetPage = createAsyncThunk(
    "BudgetItemsRequestedFromSoman/ValidationBudgetPage",
    async (parameters, { rejectWithValue }) => {
      try {
          await initializeApiClient();
          const apiClient = await getApiClient();
          const response = await apiClient.post(
              "api/Validation/ValidationBudgetPage",
              parameters
            );
  
            const data = response.data.result; // Assuming response has a "data" field
            return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

  




const BudgetItemsRequestedFromSomanReducers = createSlice({
  name: "FetchDataJson",
  initialState: {
    GetAllBudgetItemsRequestedFromSomanByAppGuid: {},
    loadingGetAllBudgetItemsRequestedFromSomanByAppGuid: false,
    errorGetAllBudgetItemsRequestedFromSomanByAppGuid: null,


    GetBudgetItemsRequestedFromSomanById: {},
    loadingGetBudgetItemsRequestedFromSomanById: false,
    errorGetBudgetItemsRequestedFromSomanById: null,

    DeleteBudgetItemsRequestedFromSomanById: {},
    loadingDeleteBudgetItemsRequestedFromSomanById: false,
    errorDeleteBudgetItemsRequestedFromSomanById: null,
   

    AddBudgetItemsRequestedFromSoman: {},
    loadingAddBudgetItemsRequestedFromSoman: false,
    errorAddBudgetItemsRequestedFromSoman: null,


    EditBudgetItemsRequestedFromSoman: {},
    loadingEditBudgetItemsRequestedFromSoman: false,
    errorEditBudgetItemsRequestedFromSoman: null,


    Validation: [],
    loadingValidation: false,
    errorValidation: null,



  },
  reducers: {
    SetValidation: (state, action) => {
      state.Validation = action.payload;
    },
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAllBudgetItemsRequestedFromSomanByAppGuid.pending, (state, action) => {
        state.loadingGetAllBudgetItemsRequestedFromSomanByAppGuid = true;
        state.GetAllBudgetItemsRequestedFromSomanByAppGuid = action.payload;
        state.errorGetAllBudgetItemsRequestedFromSomanByAppGuid = null;
      })
      .addCase(GetAllBudgetItemsRequestedFromSomanByAppGuid.fulfilled, (state, action) => {
        state.loadingGetAllBudgetItemsRequestedFromSomanByAppGuid = false;
        state.GetAllBudgetItemsRequestedFromSomanByAppGuid = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllBudgetItemsRequestedFromSomanByAppGuid.rejected, (state, action) => {
        state.loadingGetAllBudgetItemsRequestedFromSomanByAppGuid = false;
        state.errorGetAllBudgetItemsRequestedFromSomanByAppGuid = action.payload;
      });

      builder
      .addCase(GetBudgetItemsRequestedFromSomanById.pending, (state, action) => {
        state.loadingGetAllBudgetItemsRequestedFromSomanByAppGuid = true;
        state.GetBudgetItemsRequestedFromSomanById = action.payload;
        state.errorGetBudgetItemsRequestedFromSomanById = null;
      })
      .addCase(GetBudgetItemsRequestedFromSomanById.fulfilled, (state, action) => {
        state.loadingGetAllBudgetItemsRequestedFromSomanByAppGuid = false;
        state.GetBudgetItemsRequestedFromSomanById = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetBudgetItemsRequestedFromSomanById.rejected, (state, action) => {
        state.loadingGetAllBudgetItemsRequestedFromSomanByAppGuid = false;
        state.errorGetBudgetItemsRequestedFromSomanById = action.payload;
      });

      builder
      .addCase(DeleteBudgetItemsRequestedFromSomanById.pending, (state, action) => {
        state.loadingDeleteBudgetItemsRequestedFromSomanById = true;
        state.DeleteBudgetItemsRequestedFromSomanById = action.payload;
        state.errorDeleteBudgetItemsRequestedFromSomanById = null;
      })
      .addCase(DeleteBudgetItemsRequestedFromSomanById.fulfilled, (state, action) => {
        state.loadingDeleteBudgetItemsRequestedFromSomanById = false;
        state.DeleteBudgetItemsRequestedFromSomanById = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteBudgetItemsRequestedFromSomanById.rejected, (state, action) => {
        state.loadingDeleteBudgetItemsRequestedFromSomanById = false;
        state.errorDeleteBudgetItemsRequestedFromSomanById = action.payload;
      });


      builder
      .addCase(AddBudgetItemsRequestedFromSoman.pending, (state, action) => {
        state.loadingAddBudgetItemsRequestedFromSoman = true;
        state.AddBudgetItemsRequestedFromSoman = action.payload;
        state.errorAddBudgetItemsRequestedFromSoman = null;
      })
      .addCase(AddBudgetItemsRequestedFromSoman.fulfilled, (state, action) => {
        state.loadingAddBudgetItemsRequestedFromSoman = false;
        state.AddBudgetItemsRequestedFromSoman = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddBudgetItemsRequestedFromSoman.rejected, (state, action) => {
        state.loadingAddBudgetItemsRequestedFromSoman = false;
        state.errorAddBudgetItemsRequestedFromSoman = action.payload;
      });


      builder
      .addCase(EditBudgetItemsRequestedFromSoman.pending, (state, action) => {
        state.loadingEditBudgetItemsRequestedFromSoman = true;
        state.EditBudgetItemsRequestedFromSoman = action.payload;
        state.errorEditBudgetItemsRequestedFromSoman = null;
      })
      .addCase(EditBudgetItemsRequestedFromSoman.fulfilled, (state, action) => {
        state.loadingEditBudgetItemsRequestedFromSoman = false;
        state.EditBudgetItemsRequestedFromSoman = action.payload; // Assuming payload has the desired data
      })
      .addCase(EditBudgetItemsRequestedFromSoman.rejected, (state, action) => {
        state.loadingEditBudgetItemsRequestedFromSoman = false;
        state.errorEditBudgetItemsRequestedFromSoman = action.payload;
      });



      builder
      .addCase(ValidationBudgetPage.pending, (state, action) => {
        state.loadingValidation = true;
        state.Validation = action.payload;
        state.errorValidation = null;
      })
      .addCase(ValidationBudgetPage.fulfilled, (state, action) => {
        state.loadingValidation = false;
        state.Validation = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidationBudgetPage.rejected, (state, action) => {
        state.loadingValidation = false;
        state.errorValidation = action.payload;
      });




  },
});





export const { SetValidation } = BudgetItemsRequestedFromSomanReducers.actions;

export default BudgetItemsRequestedFromSomanReducers.reducer;
